<div class="row cancelform-container">
  <div class="col-12">
    <div class="card" *ngIf="!isLoading && cancelformList">
      <div class="card-header">
        Cancel Contacts
      </div>

      <div class="card-body p-0">
        <div class="card">
          <div class="card-body pl-0 pr-0 pb-0">
            <form [formGroup]="fiterForm">
              <a
                class="cursor-pointer hidden-xl-up pl-2"
                (click)="
                  utilService.toggleDivClass('filter-cancelforms', 'hidden-lg-down')
                "
              >
                <i class="fa fa-plus mr-2"></i
                ><i class="fa fa-minus mr-2 d-none"></i>Filter
              </a>
              <div class="row filter-header hidden-lg-down" id="filter-cancelforms">
                <div class="col-12 d-xl-flex align-items-start">
                  <div class="col-12 col-xl-3">
                    <div class="form-group mb-0">
                      <label class="d-block">Dealership Name</label>
                      <input
                        type="text"
                        name="filter-name"
                        class="form-control"
                        formControlName="dealerName"
                        (keypress)="omit_special_char($event)"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-xl-3">
                    <div class="form-group mb-0">
                      <label class="d-block">Dealer Number</label>
                      <input
                        type="text"
                        name="filter-dealerNumber"
                        class="form-control"
                        formControlName="dealerNumber"
                        (keypress)="omit_special_char($event)"
                      />
                    </div>
                  </div>
                   <div class="col-12 col-xl-2">
                    <div class="form-group mb-0 pos-rel">
                      <label class="d-block">Date From</label>
                      <input
                        class="form-control small-date"
                        type="text"
                        name="createdAt"
                        ngbDatepicker
                        placeholder="From"
                        #date_from="ngbDatepicker"
                        (click)="date_from.toggle()"
                        formControlName="date_from"
                        [readonly]="true"
                        [minDate]="{ year: 1900, month: 1, day: 1 }"
                        [maxDate]="{
                          year: utilService.getCurrentYear,
                          month: utilService.getCurrentMonth,
                          day: utilService.getCurrentDay
                        }"
                      />
                      <a
                        class="ng2-smart-action ng2-smart-action-delete-delete cursor-pointer pos-abs datecancel pt-4"
                        (click)="utilService.removeDate(fiterForm, 'date_from')"
                        placement="left"
                        ngbTooltip="Remove"
                        *ngIf="fiterForm.controls['date_from'].value"
                      >
                        <i class="ti-close text-danger m-r-5"></i>
                      </a>
                    </div>
                  </div>
                  <div class="col-12 col-xl-2">
                    <div class="form-group mb-0 pos-rel">
                      <label class="d-block">Date To</label>
                      <input
                        class="form-control small-date"
                        type="text"
                        name="createdAt"
                        ngbDatepicker
                        placeholder="To"
                        #date_to="ngbDatepicker"
                        (click)="date_to.toggle()"
                        formControlName="date_to"
                        [readonly]="true"
                        [minDate]="{ year: 1900, month: 1, day: 1 }"
                        [maxDate]="{
                          year: utilService.getCurrentYear,
                          month: utilService.getCurrentMonth,
                          day: utilService.getCurrentDay
                        }"
                      />
                      <a
                        class="ng2-smart-action ng2-smart-action-delete-delete cursor-pointer pos-abs datecancel pt-4"
                        (click)="utilService.removeDate(fiterForm, 'date_to')"
                        placement="left"
                        ngbTooltip="Remove"
                        *ngIf="fiterForm.controls['date_to'].value"
                      >
                        <i class="ti-close text-danger m-r-5"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        class="card-body"
        [ngClass]="{ 'p-0': cancelformList && cancelformList.length > 0 }"
      >
        <div
          class="table table-responsive smart-table"
          *ngIf="cancelformList && cancelformList.length > 0"
        >
          <table class="w-100">
            <thead>
              <tr>
                <th>Dealership Name</th>
                <th>Dealer Number</th>
                <th>Created</th>
                <th>Contacts</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cancelform of cancelformList">
                <td>
                  <a
                    (click)="onClickSelectAgent(cancelform)"
                    class="f-500 cursor-pointer text-primary"
                  >
                    {{ cancelform.dealerName }}
                  </a>
                </td>
                <td>
                  {{ cancelform.dealerNumber }}
                </td>
                 <td>{{ cancelform.createdAt | date: 'MM/dd/yyyy' }}</td>
                <td>
                  <table style="width: 100%;" cellspacing="0" cellpading="0">
                    <thead>
                      <th>Name</th>
                      <th>Title</th>
                      <th>Email</th>
                    </thead>
                    <tbody>                  
                      <ng-container *ngFor="let con of cancelform.contacts; let i = index">
                        <tr *ngIf="con.email">
                          <td>{{con.name}}</td>
                          <td>{{con.title}}</td>
                          <td>{{con.email}}</td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <app-no-data-msg
          [message]="'No cancel forms Found'"
          *ngIf="cancelformList && cancelformList.length === 0"
        ></app-no-data-msg>
      </div>
      <!-- <div class="card-footer" *ngIf="cancelformList && cancelformList.length > 0">
        <div
          class="pagination-container d-flex align-items-center justify-content-between"
        >
          <span>{{
            utilService.showPaginationInfo(cancelformList, perPage, currentPage)
          }}</span>
          <pagination-controls
            class="my-pagination"
            (pageChange)="currentPage = $event"
          ></pagination-controls>
        </div>
      </div> -->
      <div class="card-footer" *ngIf="cancelformList && cancelformList.length > 0">
        <div class="row">
          <div class="col-md">
            <span>{{
              utilService.showPaginationInfoNew(
                pager.Totalrecords,
                pager.perPage,
                pager.currentPage
              )
            }}</span>
          </div>
          <div class="col-sm">
            <form [formGroup]="fiterForm">
              <div class="form-group mb-0 pull-right">
                <small>Rows:</small>
                <select
                  class="form-control custom-select rows-button"
                  name="perPage"
                  formControlName="perPage"
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <input
                  *ngIf="pager.TotalPages && pager.TotalPages > 1"
                  type="number"
                  #goto
                  name="goto"
                  class="form-control goto-input"
                  placeholder="Page No"
                  min="1"
                  max="{{ pager.TotalPages }}"
                />
                <span
                  *ngIf="pager.TotalPages && pager.TotalPages > 1"
                  class="btn page-goto goto-btn"
                  (click)="goPage()"
                >
                  Go
                </span>
              </div>
            </form>
          </div>
          <div class="col-md" *ngIf="pager.TotalPages && pager.TotalPages > 1">
            <div class="">
              <ul class="pagination pull-right">
                <li>
                  <a (click)="setPage(pager.currentPage - 1)"
                    ><i class="icon-arrow-left"></i
                  ></a>
                </li>
                <li
                  *ngFor="let page of PageList"
                  [ngClass]="{ active: pager.currentPage === page.page }"
                >
                  <a (click)="setPage(page.page)">{{ page.label }}</a>
                </li>
                <li>
                  <a (click)="setPage(pager.currentPage + 1)"
                    ><i class="icon-arrow-right"></i
                  ></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-table-loader [isLoading]="isLoading"></app-table-loader>
    <ng-template #approveModal let-modal>
      <div class="modal-header">
        <h4 class="modal-title">Confirm {{currentStatus | titlecase }}</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Are you sure you want to "{{ currentStatus | titlecase }}"?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel')">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="modal.close('confirm')">Confirm</button>
      </div>
    </ng-template>
    <div class="help-container">
      <div class="help-section">
        <p class="help-text" (click)="openHelpPopup()">
          <i class="hellp-popup-icons"></i>
        </p>
      </div>
    </div>
  </div>
</div>
